import axios, { AxiosError } from "axios";

import { clearStorage, getStoredUser } from "../utils/storage";
import { AxiosHeaders } from "axios";
import { showErrorToastDanger } from "../utils/show-toast";

export const axiosInstance = axios.create({
  // app build is used for api specs to allow access to certain endpoints
  headers: {
    "x-app-build": process.env.REACT_APP_X_APP_BUILD,
  },
});

axiosInstance.interceptors.request.use((config) => {
  const user = getStoredUser();
  if (!config.headers) {
    config.headers = {} as AxiosHeaders;
  }
  config.headers.Authorization = user
    ? `Bearer ${user.tokens?.access || ""}`
    : "";
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // handle api errors when using this axios instance
    const errorResponse = error.response;
    const { status: errorCode, data: errorData } = errorResponse;
    if (errorCode === 401) {
      clearStorage();
      return;
    }

    let toastMessage = "Problem with internet connection";
    if (error instanceof AxiosError && errorResponse) {
      toastMessage = errorData?.message || "Server Error";
    }
    showErrorToastDanger(toastMessage);

    throw error;
  }
);
